import styled, { css } from 'styled-components'
import { palette } from '../../Styles/colors'
import { media } from '../../Styles/media'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5em;
  width: calc(100% * (1/4) - 1em - 1px);

  ${'' /* &:nth-child(-n + 2), &:nth-last-child(-n + 2) {
    width: calc(100% * (1/3) - 1em - 1px);
  } */}

  a {
    display: block;
    text-align: center;
  }

  a.img-anchor {
    line-height: 0;
    display: block;
  }

  p {
    margin: 0.5em 0 0 0;
  }

  ${props => props.solo && css`
    width: 100%;
    padding: 1em;

    p {
      width: 100%;
      font-size: 1em;
    }

    ${media.tablet`
      width: calc(100% * (1/5) - 1em - 1px) !important;
      padding: 0.6em;
      p { font-size: 0.6em; }
    `}

    ${media.desktop`
      width: calc(17% * (1/1) - 1em - 1px) !important;
      padding: 0.6em;
      p { font-size: 0.6em; }
    `}
  `}

  ${media.tablet`
    width: calc(100% * (1/6) - 1em - 1px);
  `}

  ${media.desktop`
    width: calc(75% * (1/10) - 1em - 1px);
  `}
`

const Avatar = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    background: ${palette.lightone};
    border: 2px solid ${palette.lightone};
    color: ${palette.base};
    text-align: center;
    line-height: 1.5em;
    border-radius: 50%;
    max-width: 100%;
    max-height: 100%;
  }

  ${props => props.solo && css`
    width: calc(100% * (1/3) - 1em - 1px);
  `}
`

export { Container, Avatar }



// WEBPACK FOOTER //
// ./src/Components/Profile/styles.js